<template>
  <div>
    <h1 class="title">Editing Component</h1>

    <div class="box has-background-light">
      <div class="field">
        <label class="label">Component Description</label>
        <textarea v-model="component.description" class="textarea" rows="5"></textarea>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Component ID</label>
            <input class="input" type="text" v-model="component.id">
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Component Unit</label>
            <input class="input" type="text" v-model="component.unit">
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Component Work</label>
            <input class="input" type="text" v-model="component.work">
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <h3 class="title is-5">Added Products</h3>
        <div class="box">
          <draggable class='dragArea products' v-model='selectedProducts' :options='{group: "products"}'>
            <div class="products__item products__item--added" v-for='(product, index) in selectedProducts' :key='index'>
              <i class="ion-md-move"></i> {{product.productID}} - {{product.productName}}
            </div>
          </draggable>
        </div>
      </div>
      <div class="column">
        <h3 class="title is-5">Add New Product</h3>
        <div class="box">
          <div class="field">
            <p class="control has-icons-left">
              <input type="text" class="input" v-model="search" placeholder="Search Products" />
              <span class="icon is-small is-left">
                <i class="ion-md-search"></i>
              </span>
            </p>
          </div>
          <draggable class="dragArea products products--search" v-model='filteredProducts' :options='{group: "products"}'>
            <div class="products__item" v-for='(product, index) in filteredList' :key='index'>
              <i class="ion-md-move"></i> {{product.productID}} - {{product.productName}}
            </div>
          </draggable>
        </div>
      </div>
    </div>

    <button class="button is-info" :disabled="loading" :class="{ 'is-loading': loading }" @click="updateProduct">Update</button>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import errorHandler from '@/errorHandler';

export default {
  components: {
    draggable,
  },

  data() {
    return {
      loading: false,
      search: '',
      component: [],
      products: [],
      selectedProducts: [],
      filteredProducts: [],
      selectedProductIDs: [],
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const urls = [
        `/api/component/${this.$route.params.id}/get`,
        '/api/product/list',
      ];

      Promise.all(urls.map(url =>
        fetch(url).then(res => res.json()))).then((data) => {
        this.component = data[0];
        this.products = data[1].products;

        if (this.component.products) {
          this.component.products.forEach((selectedProductID) => {
            this.selectedProducts.push(this.products.find(item => item.productID === selectedProductID));
          });
        }

        this.updateFilteredProducts();
      });
    },

    updateFilteredProducts() {
      const results = this.products.slice();
      this.selectedProducts.forEach((selectedProduct) => {
        results.splice(results.indexOf(selectedProduct), 1);
      });

      this.filteredProducts = results.filter(product => product.productName.toLowerCase().includes(this.search.toLowerCase()));
      return this.filteredProducts;
    },

    updateProduct() {
      this.loading = true;

      this.selectedProducts.forEach((product) => {
        this.selectedProductIDs.push(product.productID);
      });

      fetch('/api/component', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.component.id,
          description: this.component.description,
          unit: this.component.unit,
          work: this.component.work,
          products: this.selectedProductIDs,
        }),
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.loading = false;
          this.$awn.success(`Update Component ${response}`);
        });
    },
  },

  computed: {
    filteredList() {
      return this.updateFilteredProducts();
    },
  },
};
</script>

<style lang="scss" scoped>
  .products {
    height: 440px;
    overflow: scroll;

    &--search {
      height: 392px;
    }

    &__item {
      font-size: 0.9rem;
      padding: 5px 10px;
      background: #f5f5f5;
      border: 1px dashed #ccc;
      border-radius: 4px;
      cursor: move;

      &:not(:last-child) {
        margin-bottom: 10px;
      }

      &--added {
        background: #fff;
        border: 1px dashed hsl(141, 71%, 48%);
      }
    }
  }
</style>
